<!-- 主播标签管理-->
<template>
  <div>
    <div class="title">{{$route.query.name}}的标签</div>
    <x-tabula
      ref="table"
      :dataSource="dataSource"
      rowKey="tag_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptLen="4"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :deleteParam="deleteParam"
      :listApi="listApi"
      :rowSelection="false"
    >
    </x-tabula>
    <!-- 添加主播标签弹窗-->
    <a-modal v-model="visible" title="新增标签" @ok="addLabel" :width="800" v-bind="this.$store.state.modalConfig">
      <x-tabula
          ref="table"
          :dataSource="printDataSource"
          :listApi="printListApi"
          rowKey="tag_id"
          :columns="printColumns"
          :rowSelection="true"
          :searchList="printSearchList"
          :searchParams.sync="printSearchParams"
          @handleSelectChange="handleSelectChange"
        >
        </x-tabula>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'anchorLabel',
  data () {
    return {
      visible: false,
      tag_id: '',
      searchList: [
        { props: ['keywords'], placeholder: '标签名', options: [], inputType: 'input' }
      ],
      tableOptList: [
        { text: '新增', handle: (row) => { this.visible = true; }, permi: ['community:anchorLabel:add'] }
      ],
      rowOptList: [
        { text: '删除', handle: (row) => { this.$refs.table.showDeleteConfirm(row); }, permi: ['community:finance:remove'] }
      ],
      columns: [
        { title: '标签名', dataIndex: 'title', align: 'left', width: '' },
        { title: '添加人', dataIndex: 'create_user_name', align: 'left', width: '' },
        { title: '添加时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        keywords: undefined
      },
      listApi: {
        url: '', // live/anchors
        resHandle: this.resHandle, // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {
        url: '',
        param: { tag_id: '' },
        title: '标签名',
        key: 'title'
      },
      printDataSource: [],
      printColumns: [
        { title: '标签名', dataIndex: 'title', align: 'left', width: '' }
      ],
      printSearchList: [
        { props: ['keywords'], placeholder: '标签名', options: [], inputType: 'input' }
      ],
      printSearchParams: {
        keywords: undefined
      },
      printListApi: {
        url: '', // live/anchors
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      }
    };
  },
  created () {
    if (this.$route.query.id) {
      this.listApi.url = `/live/anchors/${this.$route.query.id}/tags`;
      this.deleteParam.url = `/live/anchors/${this.$route.query.id}/tags`;
      this.printListApi.url = `/live/anchors/${this.$route.query.id}/taglist`;
    }
  },
  mounted () {},
  methods: {
    addLabel () {
      this.$post({
        url: `/live/anchors/${this.$route.query.id}/tags`,
        params: {
          tag_id: this.tag_id
        }
      }).then(res => {
        if (res.code === 1) {
          this.visible = false;
          this.tag_id = '';
          this.$message.success(res.msg);
          this.$refs.table.getTableList();
        }
      });
    },
    handleSelectChange (list) {
      if (list.length) {
        let arr = list.map(item => {
          return item.tag_id;
        });
        this.tag_id = arr.join(',');
      }
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>

<style lang="scss" scoped>
.title{
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 10px;
  margin-bottom: 20px;
  border-bottom: 1px solid #e8e8e8;
}
</style>
